import React from "react";

import Footer from "../../Shared/Footer/Footer";
import NavBar from "../../Shared/NavBar/NavBar";
import Banner from "../Banner/Banner";
import Inspiration from "../Inspiration/Inspiration";
import Instagram from "../Instagram/Instagram";
import Products from "../Products/Products";
import Section2 from "../Section-2/Section2";
const Home = () => {
  return (
    <div>
      <NavBar />
      <Banner />
      <Section2 />
      <Products />
      <Inspiration />
      <Instagram />
      <Footer />
    </div>
  );
};

export default Home;
